export default __webpack_public_path__ + "static/media/bar-journeys.005465da.svg";